<template>
  <div class="product-details">
    <div class="image" :style="imageStyle">&nbsp;</div>
    <div class="description">
      <h1 class="description__title">{{ product.DESCRIPCION }}</h1>
      <p class="description__details" v-if="product.DETALLES && product.DETALLES != ''">
        {{ product.DETALLES }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    product: { required: true }
  },
  computed: {
    imageStyle() {
      const image = this.product.IMAGENURL
      return image ? { backgroundImage: `url(${image})` } : { display: 'none' }
    }
  }
}
</script>
<style lang="scss">
.product-details {
  @media screen and (max-width: 340px) {
    max-height: 7.25rem;
    .image {
      max-width: 80px;
      min-height: 6rem !important;
    }
    .description__title {
      font-size: 0.82rem !important;
    }
    .description__details {
      font-size: 0.7rem !important;
      overflow-y: scroll;
      margin-bottom: 0;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Order/OrderAddProductModal/ProductDetails.vue